import React from "react";
import Table from "components/Shared/CustomTable/Table/Table";
import Button from "components/Shared/CustomButtons/Button";
import Modal from "components/Shared/CustomModal/CustomModal";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Checkbox from "@mui/material/Checkbox";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import RestoreIcon from "@mui/icons-material/Restore";
import RejectReasonInput from "./RejectReasonInput";
export default function Collectables({
  rows,
  totalRows,
  rowsPerPage,
  setRowsPerPage,
  order,
  setOrder,
  orderBy,
  setOrderBy,
  page,
  setPage,
  searchValue,
  searchHandler,
  selectedSearchBy,
  handleSearchByChange,

  showRecycable,
  approveRecycable,
  rejectRecycable,
  isSelectable,
  canApprove,
  canReject,
  canRevive,
  showFilter,
  companies,
  setCompany,
  selectedCompany,
  bounceRecycable,
  reviveRecycable,
  rejectReason,
}) {
  const [selected, setSelected] = React.useState([]);
  const [openModal, setOpenModal] = React.useState(false);
  const [modalContent, setModalContent] = React.useState(null);

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  const handleApprove = (id) => {
    if (id) {
      setModalContent(
        <div style={{ textAlign: "center" }}>
          <ErrorOutlineRoundedIcon
            color="primary"
            style={{ width: "100px", height: "100px" }}
          />
          <h5>Are You sure want to approve this Recycable ? </h5>
          <div
            style={{
              display: "flex",
              justifyContent: "space-arround",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Button
              color="success"
              size="lg"
              onClick={() => approveRecycable(id)}
              style={{ flex: 1, margin: "0 10px" }}
            >
              Approve
            </Button>
            <Button
              color="secondary"
              size="lg"
              onClick={() => setOpenModal(false)}
              style={{ flex: 1, margin: "0 10px" }}
            >
              Cancel
            </Button>
          </div>
        </div>
      );
    } else if (selected.length !== 0) {
      setModalContent(
        <div style={{ textAlign: "center" }}>
          <ErrorOutlineRoundedIcon
            color="primary"
            style={{ width: "100px", height: "100px" }}
          />
          <h5>Are You sure want to approve those Recycables ? </h5>
          <div
            style={{
              display: "flex",
              justifyContent: "space-arround",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Button
              color="success"
              size="lg"
              onClick={() => approveRecycable(selected)}
              style={{ flex: 1, margin: "0 10px" }}
            >
              Approve
            </Button>
            <Button
              color="secondary"
              size="lg"
              onClick={() => setOpenModal(false)}
              style={{ flex: 1, margin: "0 10px" }}
            >
              Cancel
            </Button>
          </div>
        </div>
      );
    }
    setOpenModal(true);
  };
  const handleReject = (id) => {
    if (id) {
      setModalContent(
        <div style={{ textAlign: "center" }}>
          <ErrorOutlineRoundedIcon
            color="primary"
            style={{ width: "100px", height: "100px" }}
          />
          <h5>Are You sure want to Reject this recycable ? </h5>
          <RejectReasonInput
            reasonList={rejectReason}
            rejectHandler={(reasonId) => rejectRecycable(id, reasonId)}
            cancelHandler={() => setOpenModal(false)}
          />
        </div>
      );
    } else if (selected.length !== 0) {
      setModalContent(
        <div style={{ textAlign: "center" }}>
          <ErrorOutlineRoundedIcon
            color="primary"
            style={{ width: "100px", height: "100px" }}
          />
          <h5>Are You sure want to Reject those recycables ? </h5>
          <RejectReasonInput
            reasonList={rejectReason}
            rejectHandler={(reasonId) => rejectRecycable(selected, reasonId)}
            cancelHandler={() => setOpenModal(false)}
          />
        </div>
      );
    }
    setOpenModal(true);
  };
  const handleBounce = (id) => {
    setModalContent(
      <div style={{ textAlign: "center" }}>
        <ErrorOutlineRoundedIcon
          color="primary"
          style={{ width: "100px", height: "100px" }}
        />
        <h5>Are You sure want to Bounce this recycable ? </h5>
        <div
          style={{
            display: "flex",
            justifyContent: "space-arround",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Button
            color="danger"
            size="lg"
            onClick={() => bounceRecycable(id)}
            style={{ flex: 1, margin: "0 10px" }}
          >
            Bounce
          </Button>
          <Button
            color="secondary"
            size="lg"
            onClick={() => setOpenModal(false)}
            style={{ flex: 1, margin: "0 10px" }}
          >
            Cancel
          </Button>
        </div>
      </div>
    );
    setOpenModal(true);
  };
  const handleRevive = (id) => {
    if (id) {
      setModalContent(
        <div style={{ textAlign: "center" }}>
          <ErrorOutlineRoundedIcon
            color="primary"
            style={{ width: "100px", height: "100px" }}
          />
          <h5>Are You sure want to Revive Expiry of this Recycable ? </h5>
          <div
            style={{
              display: "flex",
              justifyContent: "space-arround",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Button
              color="success"
              size="lg"
              onClick={() => reviveRecycable(id)}
              style={{ flex: 1, margin: "0 10px" }}
            >
              Revive
            </Button>
            <Button
              color="secondary"
              size="lg"
              onClick={() => setOpenModal(false)}
              style={{ flex: 1, margin: "0 10px" }}
            >
              Cancel
            </Button>
          </div>
        </div>
      );
    } else if (selected.length !== 0) {
      setModalContent(
        <div style={{ textAlign: "center" }}>
          <ErrorOutlineRoundedIcon
            color="primary"
            style={{ width: "100px", height: "100px" }}
          />
          <h5>Are You sure want to Revive Expiry of those Recycables ? </h5>
          <div
            style={{
              display: "flex",
              justifyContent: "space-arround",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Button
              color="success"
              size="lg"
              onClick={() => reviveRecycable(selected)}
              style={{ flex: 1, margin: "0 10px" }}
            >
              Revive
            </Button>
            <Button
              color="secondary"
              size="lg"
              onClick={() => setOpenModal(false)}
              style={{ flex: 1, margin: "0 10px" }}
            >
              Cancel
            </Button>
          </div>
        </div>
      );
    }
    setOpenModal(true);
  };

  const selectedToolbarButtons = (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {canApprove && (
        <Button
          color="primary"
          size="lg"
          onClick={() => handleApprove()}
          style={{ margin: "0 10px" }}
        >
          Approve
        </Button>
      )}
      {canReject && (
        <Button
          color="danger"
          size="lg"
          onClick={() => handleReject()}
          style={{ margin: "0 10px" }}
        >
          Reject
        </Button>
      )}
      {canRevive && (
        <Button
          color="primary"
          size="lg"
          onClick={() => handleRevive()}
          style={{ margin: "0 10px" }}
        >
          Revive Expired date
        </Button>
      )}
    </div>
  );

  const searchByOptions = [
    {
      value: "item_name",
      label: "Item Name",
    },
    {
      value: "client_name",
      label: "Client Name",
    },
    {
      value: "client_phone",
      label: "Client phone",
    },
    {
      value: "qr_code",
      label: "QR Code",
    },
    {
      value: "branch_name",
      label: "Branch Name",
    },
  ];
  const headCells = [
    {
      id: "item_name",
      sortable: true,
      label: "Item Name",
    },
    {
      id: "user_name",
      sortable: true,
      label: "User Name",
    },
    {
      id: "user_phone",
      sortable: true,
      label: "User Phone",
    },
    { id: "qr_code", sortable: true, label: "QR Code" },
    {
      id: "branch_name",
      sortable: true,
      label: "Branch Name",
    },
    {
      id: "created_at",
      sortable: true,
      label: "Created Date",
    },
    { id: "options", sortable: false, label: "Options" },
  ];

  const tableCells = (
    <>
      {rows.length !== 0 ? (
        rows.map((row, index) => {
          const isItemSelected = isSelected(row.id);
          const labelId = `enhanced-table-checkbox-${index}`;

          return (
            <TableRow key={row.id} hover>
              {isSelectable && (
                <TableCell padding="checkbox">
                  <Checkbox
                    onClick={(event) => handleClick(event, row.id)}
                    checked={isItemSelected}
                    inputProps={{ "aria-labelledby": labelId }}
                    color="primary"
                  />
                </TableCell>
              )}
              <TableCell
                component="th"
                id={labelId}
                scope="row"
                padding="normal"
                align="center"
              >
                {row.item_name}
              </TableCell>
              <TableCell
                component="th"
                id={labelId}
                scope="row"
                padding="normal"
                align="center"
              >
                {row.client_name}
              </TableCell>
              <TableCell
                component="th"
                id={labelId}
                scope="row"
                padding="normal"
                align="center"
              >
                {row.client_phone}
              </TableCell>
              <TableCell
                component="th"
                id={labelId}
                scope="row"
                padding="normal"
                align="center"
              >
                {row.qr_code}
              </TableCell>
              <TableCell
                component="th"
                id={labelId}
                scope="row"
                padding="normal"
                align="center"
              >
                {row.branch_name}
              </TableCell>
              <TableCell
                component="th"
                id={labelId}
                scope="row"
                padding="normal"
                align="center"
              >
                {new Date(row.created_at).toLocaleString()}
              </TableCell>
              <TableCell component="th" padding="normal" align="center">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "flex-start",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    {canApprove && (
                      <Tooltip title="Approve">
                        <IconButton
                          aria-label="approve"
                          onClick={() => handleApprove([row.id])}
                        >
                          <CheckIcon />
                        </IconButton>
                      </Tooltip>
                    )}
                    {canReject && (
                      <Tooltip title="Reject">
                        <IconButton
                          aria-label="reject"
                          onClick={() => handleReject([row.id])}
                        >
                          <ClearIcon color="error" />
                        </IconButton>
                      </Tooltip>
                    )}
                    {row.is_collected === 1 && row.is_archived === 0 && (
                      <Tooltip title="Bounce">
                        <IconButton
                          aria-label="bounce"
                          onClick={() => handleBounce(row.id)}
                        >
                          <ExitToAppIcon color="error" />
                        </IconButton>
                      </Tooltip>
                    )}
                    {canRevive && (
                      <Tooltip title="Revive Expiry">
                        <IconButton
                          aria-label="revive"
                          onClick={() => handleRevive([row.id])}
                        >
                          <RestoreIcon color="primary" />
                        </IconButton>
                      </Tooltip>
                    )}
                  </div>
                  <Tooltip title="open collectable details">
                    <IconButton
                      aria-label="show"
                      onClick={() => showRecycable(row.id)}
                    >
                      <VisibilityIcon color="primary" />
                    </IconButton>
                  </Tooltip>
                </div>
              </TableCell>
            </TableRow>
          );
        })
      ) : (
        <TableRow>
          <TableCell colSpan={12} align="center">
            No Collectables Found
          </TableCell>
        </TableRow>
      )}
    </>
  );
  return (
    <React.Fragment>
      <Table
        rows={rows}
        totalRows={totalRows}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        order={order}
        setOrder={setOrder}
        orderBy={orderBy}
        setOrderBy={setOrderBy}
        page={page}
        setPage={setPage}
        searchHandler={searchHandler}
        searchValue={searchValue}
        selectedSearchBy={selectedSearchBy}
        handleSearchByChange={handleSearchByChange}
        tableCells={tableCells}
        selected={selected}
        setSelected={setSelected}
        headCells={headCells}
        isSelectable={isSelectable}
        selectedToolbarButtons={selectedToolbarButtons}
        toolbarButtons={null}
        showSearchBy={true}
        searchByOptions={searchByOptions}
        showFilter={showFilter}
        filterTitle={"Filter By Company"}
        selectedFilter={selectedCompany}
        handleFilterChange={(e) => setCompany(e.target.value)}
        filterOptions={companies}
        handleFilterReset={() => setCompany("")}
      />
      <Modal open={openModal} handleClose={() => setOpenModal(false)}>
        {modalContent}
      </Modal>
    </React.Fragment>
  );
}
